"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getGlobalValue(mapping) {
    if (mapping.value) {
        return mapping.value;
    }
    // Stubbed at the moment
    return mapping.key;
}
exports.getGlobalValue = getGlobalValue;
//# sourceMappingURL=globalStore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/globalStore.js
// module id = 678
// module chunks = 1